import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  formatDecimal,
  getIncreaseSymbol,
  CONVERSION_STATUS_TYPE,
  isPositive,
  BUDGET_OPPORTUNITY_TYPES,
} from '@bingads-webui-campaign/recommendation-core';

import template from './delta.pug';

export class ConversionDeltaColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, isOptimizationScoreOn }) {
    const title = i18n.getString('Details_View_Est_Conv_Abbr');

    super({
      name: 'ConversionDelta',
      property: 'EstimatedIncreaseInConversionsInt',
      title,
      bodyClasses: ['grid-column-ConversionsIncrease'],
      colClasses: ['col-numberEst'],
      sortable: true,
      helpId: 'Pop_BA_Recommendations_EstChangeConversions',
      type: 'number',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.i18n = i18n;
    this.isOptimizationScoreOn = isOptimizationScoreOn;
  }

  template({
    value: {
      OpportunityType,
      ConversionSummaryStatus,
      CurrentConversionsInt,
      EstimatedIncreaseInConversionsInt,
      HistoricalConversions,
    },
  }) {
    const { i18n, isOptimizationScoreOn } = this;
    // When the type is BUDGET_OPPORTUNITY_TYPES
    if (_.contains(BUDGET_OPPORTUNITY_TYPES, OpportunityType) &&
      ConversionSummaryStatus !== CONVERSION_STATUS_TYPE.HAS_DATA) {
      return template({
        i18n,
        isNegative: false,
        notAvailable: true,
        isOptimizationScoreOn,
      });
    }

    if (!_.isNumber(CurrentConversionsInt) || !_.isNumber(EstimatedIncreaseInConversionsInt)) {
      return template({
        i18n,
        isNegative: false,
        notAvailable: true,
        isOptimizationScoreOn,
      });
    }

    let baseConversion;
    if (_.isNumber(HistoricalConversions)) {
      baseConversion = HistoricalConversions;
    } else {
      baseConversion = CurrentConversionsInt;
    }

    return template({
      deltaVal: formatDecimal(EstimatedIncreaseInConversionsInt, i18n),
      fromVal: formatDecimal(baseConversion, i18n),
      toVal: formatDecimal(baseConversion + EstimatedIncreaseInConversionsInt, i18n),
      i18n,
      increaseSymbol: getIncreaseSymbol(EstimatedIncreaseInConversionsInt),
      isNegative: !isPositive(EstimatedIncreaseInConversionsInt),
      isOptimizationScoreOn,
    });
  }

  get property() {
    return {
      get: _.identity,
      key: 'EstimatedIncreaseInConversionsInt',
    };
  }
}
